export const DCR_STATUS = [
    'new',
    'rejected',
    'not under dsi',
    'ongoing',
    'on-hold',
    'completed'
]

export const DCR_IMPLEMENTED_BY = [
    "DSI",
    "DAMPS",
    "Third-Party"
]

export const get_data_maintenance_files = (data_maintenance:any) =>{
    // console.debug("opening", data_maintenance);
    return `data_maintenance/${data_maintenance.type}_${data_maintenance?.data_id?.replace(/\//g, '_')}`
}